import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AumyeGoogleMapLoadService {
  private apiKey: string = 'AIzaSyCQSAPyJAtLpIfNx-6oyXpn270bS0hVP18';
  private callbackName: string = 'initMap';
  private isLoaded: boolean = false;
  private loadPromise: Promise<void>;
  constructor() {
    this.loadPromise = new Promise<void>((resolve, reject) => {
      if (this.isLoaded) {
        resolve();
        return;
      }

      (window as any)[this.callbackName] = () => {
        this.isLoaded = true;
        resolve();
      };

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=visualization&callback=${this.callbackName}`;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  load(): Promise<void> {
    return this.loadPromise;
  }
}
